import React, { useEffect, useState } from 'react'
import Item from './Item'
import styles from './index.module.less'

interface SpecProps {
  /**数据源 */
  dataSource?: Array<SwaggerDTO.GoodsExtInfoDTO>
  value?: SwaggerDTO.GoodsExtInfoDTO
  onChange?: (item?: SwaggerDTO.GoodsExtInfoDTO) => void
  skuStocks?: Object
}

export default function Spec({
  dataSource,
  value,
  onChange,
  skuStocks,
}: SpecProps) {
  const [activate, setActivate] = useState<
    SwaggerDTO.GoodsExtInfoDTO | undefined
  >()

  useEffect(() => {
    setActivate(value)
  }, [value])

  return (
    <div className={styles.spec}>
      {dataSource
        ?.filter(
          c => c.onSale === 1 && !c?.advanceSale && c?.publishStatus === 2
        )
        ?.map(
          item =>
            item.publishStatus === 2 && (
              <Item
                disable={
                  !skuStocks?.[item.skuCode] ||
                  !!item.soldOut ||
                  !item.onSale ||
                  !!item.advanceSale
                }
                imgSrc={item.imgUrl}
                key={item.skuCode}
                label={item.skuName}
                checked={activate?.skuCode === item.skuCode}
                onChange={status => {
                  let changeValue = status ? item : undefined

                  setActivate(changeValue)
                  onChange?.(changeValue)
                }}
              />
            )
        )}
    </div>
  )
}
